import { useEffect } from "react";
import { BOOKING_URL, CELINA_BOOKING_URL, PHONE_HREF } from "@/components/glam/data";

/**
 * Registers in-page WebMCP tools so AI agents can book, shop, or call
 * without reverse-engineering the UI.
 */
export function useSalonAgentTools() {
  useEffect(() => {
    const modelContext = document.modelContext;
    if (!modelContext?.registerTool) return;

    const controller = new AbortController();
    const { signal } = controller;

    void modelContext.registerTool(
      {
        name: "book_appointment",
        description:
          "Open The Glam Room online booking page so a guest can schedule a hair salon or extension appointment in Wellington, Florida.",
        inputSchema: {
          type: "object",
          properties: {},
        },
        execute() {
          window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
          return {
            content: [
              {
                type: "text",
                text: "Opened The Glam Room booking page in a new tab.",
              },
            ],
          };
        },
      },
      { signal },
    );

    void modelContext.registerTool(
      {
        name: "shop_extension_bar",
        description:
          "Open The Celina Collection hair extension bar booking menu so a guest or stylist can shop in-stock extension hair.",
        inputSchema: {
          type: "object",
          properties: {},
        },
        execute() {
          window.open(CELINA_BOOKING_URL, "_blank", "noopener,noreferrer");
          return {
            content: [
              {
                type: "text",
                text: "Opened The Celina Collection extension bar menu in a new tab.",
              },
            ],
          };
        },
      },
      { signal },
    );

    void modelContext.registerTool(
      {
        name: "call_salon",
        description: "Start a phone call to The Glam Room at (561) 855-7493.",
        inputSchema: {
          type: "object",
          properties: {},
        },
        execute() {
          window.location.assign(PHONE_HREF);
          return {
            content: [{ type: "text", text: "Started a call to The Glam Room." }],
          };
        },
      },
      { signal },
    );

    return () => controller.abort();
  }, []);
}
